import { useGLTF } from '@react-three/drei'; // useProgress
import { MeshCollider, RigidBody } from '@react-three/rapier';
import { useContext } from 'react'; // Suspense, useMemo,
// import { TextureLoader, DoubleSide, FrontSide } from "three";

import lyoc_table from '@/assets/models/lyoc_table_6.glb';
import EnergyBuilderCarbonReservoir from '@/components/game/3d/builder/energy/EnergyBuilderCarbonReservoir';
import EnergyBuilderWorldEnergyPool from '@/components/game/3d/builder/energy/EnergyBuilderWorldEnergyPool';
import { GameContext } from '@/state/contexts';
import { useTutorial } from '@/hooks/useTutorial';
import { tutStep_6 } from '@/lyoc-common/src/const/tutorial';

const Table = () => {
	const { carbonReservoir, worldEnergy }: any = useContext(GameContext);

	const { nodes, materials } = useGLTF(lyoc_table);

	const { tutorialCheck } = useTutorial();

	return (
		<>
			<RigidBody colliders={false} type="fixed">
				<MeshCollider type="trimesh">
					<primitive object={nodes.lyoc_table} />
				</MeshCollider>
			</RigidBody>

			{tutorialCheck(tutStep_6) &&
				<EnergyBuilderCarbonReservoir
					numCarbon={carbonReservoir}
					initPos={[-4, 2, -4]}
				/>
			}

			<EnergyBuilderWorldEnergyPool
				worldEnergy={worldEnergy}
				initPos={[6, 2, -4]}
			/>
		</>
	);
};

//  <meshBasicMaterial attach="material" map={texture} side={FrontSide} />

useGLTF.preload(lyoc_table);

export default Table;
